import { OneCreatePostDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import { OneCreateAction, OneCreationActionResolver } from 'modules/core/lib/oneCreateActions/types'
import { POSTS_POLICIES } from 'modules/posts/lib/postsPolicies'

const useCreatePostActionResolver: OneCreationActionResolver = () => {
  const { navigation } = useNavigation()

  const [createPost, { loading }] = useMutation(OneCreatePostDocument, {
    extractorFn: (data) => data.postsMutations.createPostsPost,
    errorPolicy: 'all',
  })

  const createPostHandler = async (args: {
    type: string
    title: string
    description: string
    postGroupId: string
    targetId?: string
    startsAt?: string
    endsAt?: string
    location?: string
    allowCommentsAndReactions?: boolean
    sendNotifications?: boolean
    mentionedAccessIds?: string[]
  }) => {
    const {
      type,
      title,
      description,
      postGroupId,
      targetId,
      startsAt,
      endsAt,
      location,
      allowCommentsAndReactions = true,
      sendNotifications = false,
      mentionedAccessIds = [],
    } = args

    const result = await createPost({
      variables: {
        type,
        title: title.trim(),
        description: description.trim(),
        postGroupId,
        targetId: targetId ?? undefined,
        startsAt: startsAt ?? undefined,
        endsAt: endsAt ?? undefined,
        location: location ?? undefined,
        allowCommentsAndReactions,
        sendNotifications,
        mentionedAccessIds,
      },
    })

    const handled = handleResult(result, (_errors) => {})

    if (handled.success && handled.data.post?.id) {
      return {
        to: navigation.communities.post.id.fullPath({ id: handled.data.post.id }),
        data: args,
      }
    }

    return handled
  }

  return {
    resolver: createPostHandler,
    loading,
  }
}

export const CreatePostAction: OneCreateAction = {
  actionResolver: useCreatePostActionResolver,
  policies: [POSTS_POLICIES.groupCanPostSomewhere],
}
